import React from 'react';
import './modal.css'; // Optional: Add styles in modal.css
import Slanje from "./picture/slanje.png";
import Close from "./picture/close.png";

const Modal = ({ message, onConfirm, onCancel }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <p>{message}</p>
                <div className="modal-buttons">
                    <button className="send-btn" onClick={onConfirm}>
                        <img src={Slanje} alt="" />
                    </button>
                    <button className="cancel-btn" onClick={onCancel}>
                        <img src={Close} alt="" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
